import axios from 'axios';
import { createContext, useContext } from 'react';
import { AuthContext } from './AuthContext';
import * as dayjs from 'dayjs';
const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone'); // dependent on utc plugin

dayjs.extend(utc);
dayjs.extend(timezone);

const FetchContext = createContext();
const { Provider } = FetchContext;

function FetchProvider({ children }) {
  const authContext = useContext(AuthContext);
  const privateFetch = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });
  const tenant = window.location.hostname.split('.')[0];

  privateFetch.interceptors.request.use(
    function (config) {
      config.headers['app-timezone'] = dayjs.tz.guess();
      config.headers.Authorization = `Bearer ${authContext.authState.token}`;
      config.headers['app-tenant'] = tenant;
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  function responseInterceptor() {
    const resInterceptor = privateFetch.interceptors.response.use(
      function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
      },
      function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error

        const { config: originalRequest, response = {} } = error ?? {};

        if (response?.status === 401 && authContext.authState.token) {
          axios.interceptors.response.eject(resInterceptor);

          return axios
            .post(`${process.env.REACT_APP_API_URL}/v1/admin/refreshtoken`, {
              refreshtoken: authContext.authState.refreshToken,
            })
            .then((response) => {
              const { accessToken: token, refreshToken } = response?.data?.data;
              authContext.setTokens({ token, refreshToken });

              originalRequest.headers.Authorization = `Bearer ${token}`;

              return axios(originalRequest);
            })
            .catch((error) => {
              authContext.logout();

              return Promise.reject(error);
            })
            .finally(responseInterceptor);
        }

        return Promise.reject(error);
      }
    );
  }

  responseInterceptor();

  return (
    <Provider
      value={{
        privateFetch,
      }}
    >
      {children}
    </Provider>
  );
}

export { FetchProvider, FetchContext };
